import { gql } from '__generated__';

export default gql(`
  mutation AddOrder($input: AddOrderInput!) {
    addOrder(input: $input) {
      id
      participant {
        id
      }
    }
  }
`);
